import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { PreloaderContextProvider } from '@flicent/fieldpulse-react-component-library-frontend';

import { IS_BUILD_FOR_OFFLINE } from "@/constants";

import App from './App';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// We use HashRouter for Offline Mode, to be able to navigate the app
// Because in mobile app the html is served from the File System in Webview on Mobile, where BrowserRouter wouldn't work
const Router = IS_BUILD_FOR_OFFLINE ? HashRouter : BrowserRouter;
// -------------------------------------------------------------------------------------------

root.render(
  <Router>
    <PreloaderContextProvider>
      <App/>
    </PreloaderContextProvider>
  </Router>
);